import { BaseEntity } from "yt-ng-framework";

export class Provajder extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string = null;
    Url: string = null;
    GenericName: string = null;
    EotpremnicaUrl: string = null;



    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Url = input.Url;
        this.GenericName = input.GenericName;
        this.EotpremnicaUrl = input.EotpremnicaUrl;

        return this;
    }

    Serialize(input: Provajder): {} {
        return input;
    }
}